import { render, staticRenderFns } from "./PotentiallyInterestedCompanies.vue?vue&type=template&id=fedda5f8&scoped=true&"
import script from "./PotentiallyInterestedCompanies.vue?vue&type=script&lang=js&"
export * from "./PotentiallyInterestedCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedda5f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
